<div [ngClass]="stackVertical() ? 'vflex-300' : 'hflex-200'">
  <div class="example pad-300">
    <ng-container *ngTemplateOutlet="sampleContent()"></ng-container>
  </div>

  @if (sampleSnippet$ | async; as snippet) {
    <div
      class="samples vflex-050 surface-muted border-radius-200"
      >
      @if (snippet.html) {
        <pre
          class="html fill-flex scrollable"
          ><code [innerHtml]="createSampleMarkup(snippet.html)"></code></pre>
        }
        @if (snippet.code) {
          <pre
            class="ts fill-flex scrollable"
            ><code [innerHtml]="createSampleCode(snippet.code)"></code></pre>
          }
          @if (snippet.styles) {
            <pre
              class="scss fill-flex scrollable"
              ><code [innerHtml]="createSampleCode(snippet.styles)"></code></pre>
            }
          </div>
        }
      </div>
